"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RefurbishedLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationHandset = require("../../../../hooks/recommendation/useRecommendationHandset");
var _services = require("../../../../services");
var _useCustomer = require("../../../../hooks/questionnaire/useCustomer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OverwriteStyling = _styledComponents.default.div`
  ul {
    max-width: 100%;
  }
`;
const RefurbishedLabel = _styledComponents.default.span`
  color: ${props => props.theme.color.primary1.default};
`;
exports.RefurbishedLabel = RefurbishedLabel;
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  & .injected-svg {
    stroke: #0d0d0d;
  }
`;
const VariancePicker = _ref => {
  var _filters$refurbishedC5, _filters$refurbishedC6, _filters$refurbishedC7, _filters$refurbishedC8, _filters$refurbishedC9, _filters$refurbishedC10, _filters$refurbishedC11, _filters$refurbishedC12;
  let {
    handset,
    handsetIndex
  } = _ref;
  const {
    filters,
    onVariantSelect
  } = (0, _useRecommendationHandset.useRecommendationHandset)(handset);
  const {
    colorVariants,
    memoryVariants,
    selectedColor,
    selectedMemory,
    refurbishedCondition
  } = filters;
  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const renderMemoryOptions = memoryVariants !== null && memoryVariants !== void 0 && memoryVariants.length ? /*#__PURE__*/_react.default.createElement(OverwriteStyling, {
    "data-test-id": `selected-capacity-${handsetIndex}`
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SelectInputWithMenuWithLabel, {
    fieldWrapper: {
      label: _services.locale.localeString('Recommendation.CapacityLabel'),
      width: 'full'
    },
    selectInputWithMenu: {
      id: `recommendation-handset-capacity`,
      required: true,
      value: selectedMemory.value,
      onChange: value => {
        onVariantSelect(handset.productId, value);
      },
      options: memoryVariants
    }
  })) : null;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, colorVariants && colorVariants.length && selectedColor && selectedColor.color && /*#__PURE__*/_react.default.createElement(OverwriteStyling, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSelectWithLabel, {
    fieldWrapper: {
      label: _services.locale.localeString('Recommendation.ColorLabel'),
      width: 'full',
      dataAttributes: {
        'data-test-id': `selected-color-${handsetIndex}`
      }
    },
    colorSelect: {
      id: `recommendation-handset-dropdown-color`,
      value: selectedColor.value,
      onChange: variantId => {
        var _handset$filterTree, _handset$filterTree$f, _handset$filterTree$f2;
        const defaultVariantId = (_handset$filterTree = handset.filterTree) === null || _handset$filterTree === void 0 ? void 0 : (_handset$filterTree$f = _handset$filterTree.find(color => {
          return color.variantId == variantId;
        })) === null || _handset$filterTree$f === void 0 ? void 0 : (_handset$filterTree$f2 = _handset$filterTree$f.variants.find(variant => {
          return !variant.refurbishedCondition || variant.refurbishedCondition === (refurbishedCondition.isRefurbishedHandset ? 'Refurbished' : 'New');
        })) === null || _handset$filterTree$f2 === void 0 ? void 0 : _handset$filterTree$f2.variantId;
        onVariantSelect(handset.productId, defaultVariantId);
      },
      options: colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.filter(colorVariant => colorVariant.color)
    }
  })), selectedMemory.text ? renderMemoryOptions : null, (refurbishedCondition === null || refurbishedCondition === void 0 ? void 0 : refurbishedCondition.isRefurbishedAvailable) && /*#__PURE__*/_react.default.createElement(OverwriteStyling, {
    "data-test-id": `refurbished-${handsetIndex}`
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SelectInputWithMenuWithLabel, {
    fieldWrapper: {
      label: _services.locale.localeString('Recommendation.Refurbished'),
      width: 'full'
    },
    selectInputWithMenu: {
      id: `recommendation-handset-refurbished`,
      value: filters.refurbishedCondition.isRefurbishedHandset ? 'YES' : 'NO',
      onChange: e => {
        var _filters$refurbishedC, _filters$refurbishedC2, _filters$refurbishedC3, _filters$refurbishedC4;
        onVariantSelect(handset.productId, e === 'YES' ? (_filters$refurbishedC = filters.refurbishedCondition) === null || _filters$refurbishedC === void 0 ? void 0 : (_filters$refurbishedC2 = _filters$refurbishedC.refurbishedVariant) === null || _filters$refurbishedC2 === void 0 ? void 0 : _filters$refurbishedC2.variantId : (_filters$refurbishedC3 = filters.refurbishedCondition) === null || _filters$refurbishedC3 === void 0 ? void 0 : (_filters$refurbishedC4 = _filters$refurbishedC3.newConditionVariant) === null || _filters$refurbishedC4 === void 0 ? void 0 : _filters$refurbishedC4.variantId);
      },
      options: [{
        text: _services.locale.localeString('Recommendation.No'),
        value: 'NO',
        disabled: !((_filters$refurbishedC5 = filters.refurbishedCondition) !== null && _filters$refurbishedC5 !== void 0 && _filters$refurbishedC5.newConditionVariant)
      }, {
        text: _services.locale.localeString('Recommendation.Yes') + ` (${_services.locale.formatPrice(((_filters$refurbishedC6 = filters.refurbishedCondition.refurbishedVariantPrice) === null || _filters$refurbishedC6 === void 0 ? void 0 : _filters$refurbishedC6.priceValue) - (isCustomer ? (_filters$refurbishedC7 = (_filters$refurbishedC8 = filters.refurbishedCondition) === null || _filters$refurbishedC8 === void 0 ? void 0 : (_filters$refurbishedC9 = _filters$refurbishedC8.refurbishedVariantPrice) === null || _filters$refurbishedC9 === void 0 ? void 0 : (_filters$refurbishedC10 = _filters$refurbishedC9.discountPriceAlteration) === null || _filters$refurbishedC10 === void 0 ? void 0 : (_filters$refurbishedC11 = _filters$refurbishedC10.price) === null || _filters$refurbishedC11 === void 0 ? void 0 : (_filters$refurbishedC12 = _filters$refurbishedC11.taxIncludedAmount) === null || _filters$refurbishedC12 === void 0 ? void 0 : _filters$refurbishedC12.value) !== null && _filters$refurbishedC7 !== void 0 ? _filters$refurbishedC7 : 0 : 0))})`,
        value: 'YES'
      }]
    }
  }), (filters === null || filters === void 0 ? void 0 : filters.refurbishedCondition.isRefurbishedHandset) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1
  }, /*#__PURE__*/_react.default.createElement(RefurbishedLabel, {
    "data-test-id": `refurbished-hint-${handsetIndex}`
  }, _services.locale.localeString('Recommendation.RefurbishedMessage'))))));
};
var _default = VariancePicker;
exports.default = _default;